import React from 'react';
import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';

import InputGroup from '../InputGroup';
import Button from '../../components/Button';
import { LoadingSpinner } from '../../components/LoadingSpinner';

import { onShowLocationChangePopup } from '../../containers/Volunteer/actions';
import { isPortrait } from '../../utils/size';
import { validateEmail } from '../Shared/validations';

import { copyFor, capitalization } from '../../copy/copy';

const Thanks = styled.div`
    font-size: 14px;
    font-weight: 400;
`;

const SubscribeFormContainer = styled.form`
    position: relative;
    display: flex;
    flex-direction: column;
    width: 100%;
    span {
        cursor: pointer;
        text-decoration: none;
        color: #008eff;
    }
    > div {
        display: inline-block;
        width: 100%;
        height: 100%;
        flex: auto;
        margin-right: 0 !important;

        > div {
            width: 100%;
            display: inline-block;
            flex: auto;

            @media (max-width: 30em) {
                width: 100%;
            }

            div {
                margin-right: 0 !important;
            }

            input {
                width: 100%;

                @media (max-width: 30em) {
                    margin-bottom: 12px;
                }
            }
        }

        p {
            font-size: ${() => (isPortrait() ? 16 : 12)}px;
            margin: 0;
        }

        button {
            position: relative;
            height: 45px;
            left: 0;
            bottom: 0;
            width: 100%;
            padding: 0 1em;
            text-indent: ${props => (props.isEmailSubmitting ? '-99999px' : '0')};

            span {
                color: unset;
            }

            &:focus,
            &:active {
                outline: none;
            }

            &:hover {
                ${props =>
                    props.disabled &&
                    `   color: unset !important;
                        background-color: unset !important;
                        border: solid 1px #e5e3e3 !important;
                        span {
                            color: #cbc8c8
                        }
                    `};
            }

            + div {
                position: absolute;
                display: ${props => (props.isEmailSubmitting ? 'block' : 'none')};
                height: 22px !important;
                width: 22px !important;
                right: 50%;
                bottom: 25px;
                transform: translateX(-50%);
                margin-right: -11px;
            }
        }
    }
`;

const ChangeLocation = props => (
    <span
        onClick={() =>
            props.onShowLocationChangePopup(
                true,
                props.actionIdentifier,
                props.actionInitiated
            )
        }
    >
        {copyFor('subscribe', 'changeLocation', 'volunteer')}
    </span>
);

ChangeLocation.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    onShowLocationChangePopup: PropTypes.func.isRequired
};

const VolunteerSubscribeForm = props => (
    <SubscribeFormContainer
        numActions={props.numActions}
        volunteerForm={props.volunteerForm}
        onSubmit={props.handleSubmit}
        autocomplete="on"
        isEmailSubmitting={props.isEmailSubmitting}
        disabled={props.invalid}
    >
        {props.isEmailSubmitted ? (
            <Thanks>{copyFor('subscribe', 'thanks', 'volunteer')}</Thanks>
        ) : (
            <div>
                {props.numActions > 1 ? (
                    <p>
                        {copyFor('subscribe', 'signUp', 'volunteer')}{' '}
                        <ChangeLocation
                            onShowLocationChangePopup={props.onShowLocationChangePopup}
                            actionIdentifier={props.actionIdentifier}
                            actionInitiated={props.actionInitiated}
                        />
                        {'.'}
                    </p>
                ) : (
                    <p>
                        {copyFor('subscribe', 'noneAvailable', 'volunteer')}{' '}
                        <ChangeLocation
                            onShowLocationChangePopup={props.onShowLocationChangePopup}
                            actionIdentifier={props.actionIdentifier}
                            actionInitiated={props.actionInitiated}
                        />
                        {'.'}
                    </p>
                )}
                <Field
                    className={'fs-block'}
                    name="email"
                    component={InputGroup}
                    type="email"
                    label="Email"
                    placeholder={copyFor(
                        'placeholders',
                        'emailAddress',
                        undefined,
                        capitalization.eachWord
                    )}
                    autocomplete="off"
                />
                <Button
                    primary={true}
                    label={copyFor('buttons', 'submit', 'volunteer', capitalization.all)}
                    type="submit"
                    className="submitButton"
                    disabled={props.invalid}
                />
                <LoadingSpinner />
            </div>
        )}
    </SubscribeFormContainer>
);

VolunteerSubscribeForm.propTypes = {
    actionIdentifier: PropTypes.string.isRequired,
    actionInitiated: PropTypes.bool.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    invalid: PropTypes.bool.isRequired,
    isEmailSubmitted: PropTypes.bool,
    isEmailSubmitting: PropTypes.bool,
    numActions: PropTypes.number,
    onShowLocationChangePopup: PropTypes.func.isRequired,
    volunteerForm: PropTypes.bool
};

export default compose(
    connect(
        state => ({
            initialValues: {
                email: state.cachedFormData.email || ''
            },
            actionIdentifier: state.widget.activeAction.identifier,
            actionInitiated: state.volunteer.actionInitiated
        }),
        {
            onShowLocationChangePopup
        }
    ),
    reduxForm({
        form: 'subscribeDetailsForm',
        validateEmail,
        destroyOnUnmount: false,
        enableReinitialize: true
    })
)(VolunteerSubscribeForm);
